import React from 'react'
import Header from '../Header/Header'
import Sidebar from './Sidebar'
import Main from './Main'
import ReportDialog from '../ReportDialog/ReportDialog'

class MainPage extends React.Component {

  state = {
    sidebar: false,
    report: false
  }

  handleSidebar = () => {
    this.setState({
      sidebar: !this.state.sidebar
    })
  }

  handleReportDialog = bool => {
    this.setState({
      report: bool
    })
  }

  render() {
    const { sidebar, report } = this.state
    return (
      <React.Fragment>
        <Header handleToggle={this.handleSidebar} />
        <Sidebar sidebar={sidebar} handleToggle={this.handleSidebar} handleReportDialog={this.handleReportDialog} />
        <Main />
        <ReportDialog report={report} handleReportDialog={this.handleReportDialog} />
      </React.Fragment>
    )
  }
}

export default MainPage



// WEBPACK FOOTER //
// ./src/components/Main/MainPage.js